import React from 'react';

import { UserDetails } from 'core/lib';

export const UserDetailsContext = React.createContext<UserDetails | Partial<UserDetails> | null>(null);
